import { defineComponent as _defineComponent } from 'vue'
import { FitButton, FitHalfScreenDialogV2 } from '@tencent/wphk-ui';
import { ref } from 'vue';
import { INFO_DIALOG_CONFIG } from '../config';
import LotteryTnc from './lottery-tnc.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'lottery-info-dialog',
  setup(__props, { expose }) {

const lotteryInfoDialog = ref();

const showDialog = () => {
  lotteryInfoDialog.value.showDialog();
};

expose({
  showDialog,
});

return { __sfc: true,lotteryInfoDialog, showDialog, FitHalfScreenDialogV2, INFO_DIALOG_CONFIG, LotteryTnc }
}

})